import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExtendedNotificationComponent } from '@next/core-lib/components';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
  DialogComponent,
} from '@next/core-lib/dialog';

import { NotificationType } from '../../models/cycle.model';

export interface BalanceDialogInputData extends AbstractDialogData {
  title: string;
  information: string;
  notificationType: NotificationType;
  notificationTitle: string;
  notificationMessage: string;
}

@Component({
  selector: 'app-balance-dialog',
  templateUrl: './balance-dialog.component.html',
  styleUrls: ['./balance-dialog.component.scss'],
  imports: [DialogComponent, ExtendedNotificationComponent],
})
export class BalanceDialogComponent extends AbstractDialog {
  data = inject<BalanceDialogInputData>(MAT_DIALOG_DATA);
  protected mdDialogRef =
    inject<MatDialogRef<BalanceDialogComponent, AbstractDialogResultData>>(MatDialogRef);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    super();
  }

  confirm() {
    super.confirm();
  }

  cancel() {
    super.cancel();
  }

  alt() {
    super.alt();
  }
}
